// Where the owners' frame goes: the sidebar's places on a desktop, the tab bar's on a phone.
import type { Icon } from '../ui/icons';
import { BooksIcon, CarIcon, ChartLineIcon, HouseIcon, PencilRulerIcon } from '../ui/icons';

export interface Place {
  to: string;
  label: string;
  icon: Icon;
  /** Only this exact address (Home), not those under it. */
  end?: boolean;
}

export const OWNER_PLACES: readonly Place[] = [
  { to: '/', label: 'Home', icon: HouseIcon, end: true },
  { to: '/garage', label: 'Garage', icon: CarIcon },
  { to: '/telemetry', label: 'Telemetry', icon: ChartLineIcon },
  { to: '/library', label: 'Library', icon: BooksIcon },
  { to: '/create', label: 'Create', icon: PencilRulerIcon },
];

/** Whether a place is where the page is. */
export function isHere(place: Place, pathname: string): boolean {
  if (place.end) {
    return pathname === place.to;
  }
  return pathname === place.to || pathname.startsWith(`${place.to}/`);
}
